import axios from "axios";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { baseurl } from "../CoocpeatHome";
import Cookies from "js-cookie";

function AddressComp() {
    const navigate = useNavigate();
    const location = useLocation();
    const { savedAddresses } = location.state || {};
    // console.log(savedAddresses?.addresses, "saved addresses in address comp");

    const handleSelectAddress = async (i) => {
        // full address object
        const selectedAddressObj = savedAddresses?.addresses[i];
        const addressText = selectedAddressObj?.location?.address;

        console.log(selectedAddressObj, "selected address");

        // If already default, just navigate
        if (selectedAddressObj?.isDefault) {
            navigate("/Cart", {
                state: {
                    selectedAddress: addressText,
                    choosen: "no",
                },
            });
            return;
        }

        try {
            const response = await axios.post(`${baseurl}users/setDefaultAddress`, {
                userId: Cookies.get("userId"),
                addressId: selectedAddressObj.id,
            });

            console.log(response?.data?.defaultAddress?.location?.address, "nandaaa===>");

            if (response.status === 200) {
                const { defaultAddress } = response.data;
                const updatedAddressText = defaultAddress?.location?.address;

                console.log("Default address set successfully:", updatedAddressText);

                navigate("/Cart", {
                    state: {
                        selectedAddress: updatedAddressText,
                        choosen: "no",
                    },
                });
            }
        } catch (err) {
            console.error("Error setting default address:", err);
        }
    };



    return (
        <div className="cart-page">
            <header className="cart-header">
                <img
                    src={require("../../asset/CocopeatAssests/Arrow Pointing Left.png")}
                    alt="back"
                    onClick={() => navigate(-1)}
                />
                <h2 className="fontDG">Select Address</h2>
            </header>

            <div className="address-scroll">
                {savedAddresses?.addresses?.map((addr, i) => (
                    <div
                        key={i}
                        className="address-item"
                        onClick={() => handleSelectAddress(i)}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 12px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            marginBottom: "8px",
                            cursor: "pointer",
                        }}
                    >
                        <p style={{ margin: 0, width: "80%" }}>
                            {addr.location?.address || addr.address}
                        </p>

                        <input
                            type="radio"
                            name="selectedAddress"
                            checked={addr.isDefault === true}
                            readOnly
                            style={{
                                accentColor: addr.isDefault ? "green" : "#ccc",
                                transform: "scale(1.2)",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AddressComp;
